// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__MM9ol","signatureButtonsRight":"ModalSign_signatureButtonsRight__1hY0H"};